// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_ot-0";
export var discountCodeInput = "_ot-1";